// extracted by mini-css-extract-plugin
export var underlineArticleHeader = "_7e0cI";
export var underlineCalloutHeader = "QRTMk";
export var underlineGeneral = "rqBM-";
export var underlineLargeArticleHeader = "lJN1G";
export var underlineSectionHeader = "qrpJT";
export var underlineSectionSmallHeader = "t7u6e";
export var underlineSmallArticleHeader = "cItnv";
export var underlineTopPageHeader = "fAy6K";